import styled from 'styled-components'

export const TopRegionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  font-size: 14px;
`
